export default class extends Controller {

  connect() {
   window.print();
 }
}
